import { render, staticRenderFns } from "./PopupCard.vue?vue&type=template&id=437f70d6&"
import script from "./PopupCard.vue?vue&type=script&lang=js&"
export * from "./PopupCard.vue?vue&type=script&lang=js&"
import style0 from "./PopupCard.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QCard from 'quasar/src/components/card/QCard.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QCard,QSpace,QBtn});qInstall(component, 'directives', {ClosePopup});
